import db from "../Db";

export function GetAllMateriau() {
  return new Promise(function (resolve, reject) {
    if (!db.isOpen()) {
      db.open();
    }

    db.MATERIAU.toArray().then((result) => {
      return resolve(result);
    });
  });
}
